import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '📋',
    title: 'pages.onboarding.subscriptionCount.answer1',
    subtitle: 'pages.onboarding.subscriptionCount.answer1Subtitle',
    value: 'oneToTwo',
  },
  {
    emoji: '📦',
    title: 'pages.onboarding.subscriptionCount.answer2',
    subtitle: 'pages.onboarding.subscriptionCount.answer2Subtitle',
    value: 'threeToFive',
  },
  {
    emoji: '🏆',
    title: 'pages.onboarding.subscriptionCount.answer3',
    subtitle: 'pages.onboarding.subscriptionCount.answer3Subtitle',
    value: 'fivePlus',
  },
  {
    emoji: '🆓',
    title: 'pages.onboarding.subscriptionCount.answer4',
    subtitle: 'pages.onboarding.subscriptionCount.answer4Subtitle',
    value: 'none',
  },
]

export default function SubscriptionCountPage() {
  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.subscriptionCount.title"
    />
  )
}
